import { crc32 as w } from "@made-people/functions-crc32";
import { centraFilterResponse as k, selectionResponseSchema as F } from "@made-people/centra-checkout-api";
import { centraFiltersToGreaseFacets as b } from "@made-people/grease-centra";
import { z as T } from "zod";
import { jsx as v } from "react/jsx-runtime";
import { CountriesAndLanguagesProvider as A } from "@made-people/grease-countries-and-languages";
const C = /* @__PURE__ */ new Map();
function R(t) {
  if (!(typeof window > "u"))
    return C.get(t);
}
function L(t, r) {
  typeof window > "u" || C.set(t, r);
}
function q(t, r, n, s) {
  return async (o) => {
    const e = {
      items: [],
      meta: {
        itemsPerPage: 0,
        totalItems: 0,
        totalPages: 0,
        currentPage: 0
      },
      facets: [],
      sort: []
    };
    if (!n)
      return e;
    const u = {
      frontendContext: n,
      payload: o
    }, a = w(JSON.stringify(u));
    let c = R(a);
    if (c)
      return c;
    const d = await t.fetchFrontendProducts(u);
    if (!d)
      return e;
    const p = o.limit ?? 20, i = d.productCount, m = (o.skipFirst ?? 0) / p + 1, f = d.frontendProducts.map(
      (S) => ({
        type: "product",
        product: s.productMapper(S, n)
      })
    ), l = {
      itemsPerPage: p,
      totalItems: i,
      totalPages: Math.ceil(i / p),
      currentPage: m
    }, y = T.array(k).safeParse(d.filter), P = y.success ? y.data : [], h = b(
      P,
      o,
      r,
      s == null ? void 0 : s.sizeSortOrder
    ) ?? [];
    return c = {
      items: f,
      meta: l,
      facets: h,
      sort: []
      // Not yet supported
    }, L(a, c), c || e;
  };
}
const x = async (t, r, n, s, o) => {
  const e = {
    frontendContext: s,
    payload: t
  }, u = {
    success: {
      products: [],
      filter: [],
      productCount: 0,
      token: n.getToken() ?? ""
    },
    error: null
  };
  let a;
  try {
    a = await r.fetchFrontendProducts(e);
  } catch (c) {
    return console.error(c), u;
  }
  return a ? {
    success: {
      products: a.frontendProducts.map(
        (c) => o != null && o.productMapper ? o.productMapper(c) : c
      ),
      filter: [],
      productCount: a.productCount,
      token: n.getToken() ?? ""
    },
    error: null
  } : u;
};
async function M(t, r, n) {
  const s = r.getToken() ?? "", o = await t.initializeSelection(n, s);
  if (!o)
    return {
      error: {
        token: s,
        errors: { selection: "not found" }
      },
      success: null
    };
  const e = F.safeParse(o);
  return e.success ? (r.setToken(e.data.token), { error: null, success: e.data }) : {
    error: {
      token: s,
      errors: { selection: "not found" }
    },
    success: null
  };
}
function B(t, r) {
  const { bffClient: n, centraTokenHandler: s, frontendContext: o, productMapper: e } = r;
  return t.getSelection = async () => M(
    n,
    s,
    o
  ), t.getProducts = async (u) => x(
    u,
    n,
    s,
    o,
    e ? { productMapper: e } : void 0
  ), t;
}
const D = (t) => {
  const { children: r, ...n } = t, s = n.countriesAndLanguages.countries, o = n.countriesAndLanguages.languages, e = n.frontendContext, u = async (c, d, p) => {
    var m;
    const i = s.find(
      (f) => f.countryCode === c
    ), g = o.find(
      (f) => f.languageCode === d
    );
    if (i != null && i.countryCode && (g != null && g.languageCode) && e) {
      const f = {
        fullSlug: p,
        targetFrontendContext: {
          market: i.marketId,
          pricelist: e.pricelist,
          currencyCode: e.currencyCode,
          country: i.countryCode,
          language: g.languageCode,
          siteSlug: e.siteSlug,
          baseUrl: e.baseUrl,
          currency: e.currency
        }
      }, l = await t.bffClient.findAlternateLinkForSlug(
        f
      );
      typeof ((m = l == null ? void 0 : l.frontendContext) == null ? void 0 : m.siteSlug) == "string" && (window.location.href = `/${l.frontendContext.siteSlug}${l.alternateSlug}`);
    }
  }, a = {
    currentCountryCode: e.country,
    currentLanguageCode: e.language,
    countries: s.map((c) => ({
      ...c,
      countryCode: c.countryCode
    })),
    languages: o,
    updateCountryAndLanguage: u
  };
  return /* @__PURE__ */ v(A, { ...a, children: r });
};
async function J(t, r) {
  return await t.fetchTrustpilotProductReviews(r) ?? null;
}
async function K(t, r) {
  return await t.fetchTrustpilotProductSummary(r) ?? null;
}
async function N(t, r) {
  return await t.fetchTrustpilotStoreReviews(r) ?? null;
}
async function E(t) {
  return await t.fetchTrustpilotStoreSummary() ?? null;
}
export {
  D as BffCountriesAndLanguagesProvider,
  q as bffCentraSearch,
  x as bffCheckoutApiGetProducts,
  J as bffFetchTrustpilotProductReviews,
  K as bffFetchTrustpilotProductSummary,
  N as bffFetchTrustpilotStoreReviews,
  E as bffFetchTrustpilotStoreSummary,
  M as bffInitializeSelection,
  B as setupCentraCheckoutApiClient
};
